"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Image_1 = __importDefault(require("../../Image"));
var generateImageStyles = function (styles, itemsCount) {
    if (itemsCount === 1) {
        return __assign(__assign({}, styles), { maxWidth: '100%', maxHeight: '500px' });
    }
    else if (itemsCount === 2) {
        return __assign(__assign({}, styles), { maxWidth: '100%', maxHeight: '500px' });
    }
    else if (itemsCount === 3 || itemsCount === 4) {
        return __assign(__assign({}, styles), { maxWidth: '320px', maxHeight: '320px', position: 'absolute', left: '20%', bottom: '5%' });
    }
    else if (itemsCount === 5 || itemsCount === 6) {
        return __assign(__assign({}, styles), { maxWidth: '320px', maxHeight: '320px', position: 'absolute', left: '7%', bottom: '13%' });
    }
    else if (itemsCount < 10) {
        return __assign(__assign({}, styles), { maxWidth: '320px', maxHeight: '320px', position: 'absolute', left: '2%', bottom: '13%' });
    }
    return __assign(__assign({}, styles), { maxWidth: '100%', maxHeight: '100%' });
};
var ItemImage = function (_a) {
    var productId = _a.productId, imagePath = _a.imagePath, itemsCount = _a.itemsCount, itemImageStyles = _a.itemImageStyles, hasImage = _a.hasImage;
    return (react_1.default.createElement(react_1.Fragment, null, hasImage && imagePath && (react_1.default.createElement(Image_1.default, { id: "".concat(productId, "-image"), styles: generateImageStyles(itemImageStyles, itemsCount), src: imagePath, alt: 'productImage' }))));
};
exports.default = ItemImage;
//# sourceMappingURL=ItemImage.js.map